import templateUrl from '../../views/export-type-modal.tpl.html';

export default class ExportWorkflow {
    constructor(slug, Alert, $http, $uibModal, $translate, options) {
        this.slug = slug;
        this.alert = Alert;
        this.api = $http;
        this.modal = $uibModal;
        this.key = `export-${slug}`;
        this.title = `Export ${_.capitalize(slug)}`;
        this.level = 'selected';
        this.order = 40;
        this.slug = slug;
        this.translate = $translate;

        this.options = options || {
            // files: 'Files',
            pdf: 'PDF',
            excel: 'Excel',
            csv: 'CSV',
        }
    }

    action({}, store) {
        const options = this._prepareOptionsForStore(store);
        const translatedValue = (path) => {
            return this.translate.instant(`components.export-scheduled.${path}`);
        };

        return this.modal.open({
            templateUrl: templateUrl,
            controller: ['options', 'store', '$uibModalInstance', ExportTypeCtrl],
            controllerAs: 'vm',
            resolve: {
                store: () => {
                    return store;
                },
                options: () => {
                    return options
                }
            }
        }).result.then(({type, sendEmail}) => {
                const data = {
                    block_notification: !sendEmail,
                    type
                };

                data[this.slug] = store.getters.selectedFilters;
                data[this.slug].fields = store.state.visible;

                return this.api
                    .post(`${store.getters.exportSlug}/export`, data)
                    .then(() => {
                        if (!sendEmail) {
                            this.alert.animatedAlert(
                                translatedValue('title'),
                                translatedValue('content'),
                                'success',
                                {
                                    confirmButtonText: translatedValue('confirm')
                                },
                            ).then(() => {
                                store.ng.injector.get('$state').go('app.mo-exports.index');
                            })
                        } else {
                            this.alert.success('Export Scheduled', 'An export has been scheduled. You should receive an email with the link in a few minutes');
                        }
                    })
                    .catch(response => this.alert.handle(response));
            },
            response => this.alert.handle(response)
        );
    }

    _prepareOptionsForStore(store) {
        return this.options;
    }
}


class ExportTypeCtrl {

    constructor(options, store, $uibModalInstance) {
        this.modal = $uibModalInstance;
        this.store = store;
        this.options = options;
        this.sendEmail = false;
    }

    showFilterTag(col) {
        return col.filterable
            && col.type
            && ((typeof (this.store.state.filters[col.key]) === 'object' && this.store.state.filters[col.key] !== null && !this.isEmpty(this.store.state.filters[col.key]))
                || (this.store.state.filters[col.key] && this.store.state.filters[col.key].length)
                || (col.type === 'boolean' && (this.store.state.filters[col.key] === true || this.store.state.filters[col.key] === false))
            );
    }

    isEmpty(obj) {
        let empty = true;
        for (let key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] && obj[key].length)
                empty = false;
        }
        return empty;
    }

    displayFilter(val) {
        if (!val) {
            return val;
        }
        if (_.isArray(val)) {
            return val.join(', ');
        }

        if (val.min || val.max) {
            let date = '';
            if (val.min) {
                date = date.concat(' From: ', val.min);
            }

            if (val.max) {
                date = date.concat(' To: ', val.max);
            }
            return date;
        }

        if (_.isBoolean(val)) {
            return val ? 'Yes' : 'No';
        }
        return val;
    }

    select(type) {
        this.modal.close({
            type: type,
            sendEmail: this.sendEmail
        });
    }

    close() {
        this.modal.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/workflows/general/export-workflow.js